module.exports = __webpack_public_path__ + "static/r23-80b34c81897ddc74e437d93810673783.jpg";